'use client'

import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from 'react'

interface CartUIContextType {
  isCartOpen: boolean
  openCart: () => void
  closeCart: () => void
  toggleCart: () => void
}

const CartUIContext = createContext<CartUIContextType | undefined>(undefined)

export function CartUIProvider({ children }: { children: ReactNode }) {
  const [isCartOpen, setIsCartOpen] = useState(false)

  const openCart = useCallback(() => setIsCartOpen(true), [])
  const closeCart = useCallback(() => setIsCartOpen(false), [])
  const toggleCart = useCallback(() => setIsCartOpen(prev => !prev), [])

  return (
    <CartUIContext.Provider
      value={{ isCartOpen, openCart, closeCart, toggleCart }}
    >
      {children}
    </CartUIContext.Provider>
  )
}

export function useCartUI() {
  const context = useContext(CartUIContext)
  if (!context) {
    throw new Error('useCartUI debe usarse dentro de un CartUIProvider')
  }
  return context
}
